import React, { useState, useEffect, useRef, Fragment } from "react";
import {
    // NavLink,
  useNavigate,
  useParams
} from "react-router-dom";
import {SortableTree} from './../../sortableMenu/SortableTree'
import style from './timeline.module.css'
import '../../../static/css/datepicker.css'
import Icons from '../../module.icons';
import axios from "axios";
import Cookies from 'js-cookie';
import gsap from "gsap";
import classNames from "classnames";
import { apiCall } from "../../narrativeUtils/fetch";
import { DateToApi, getDateDifference} from "../../../utils/dates";
import { SketchPicker } from 'react-color';
import { format, zonedTimeToUtc } from 'date-fns-tz';
import Config from "../../../Config.json"
import Loader from "../../../static/svg/loader.svg";
import Modal from '../../module.modal';

import DateField from '../datefield'
import TagField from "../tag";

// Icons
import OpenLink from "../../../static/svg/openLink-w.svg";
// import {ReactComponent as Edit} from "../../static/icons/edit.svg" 
// import {ReactComponent as ArrowRight} from "../../static/icons/arrow_right.svg" 
import {ReactComponent as ArrowBack} from "../../../static/icons/arrow_back.svg";
import {ReactComponent as Close} from "../../../static/svg/close.svg"
import {ReactComponent as Delete} from "../../../static/icons/delete.svg"
import {ReactComponent as Calendar} from "../../../static/icons/calendar.svg"
import {ReactComponent as Timeline} from "../../../static/modules/timeline-icon-flat.svg";

function Module(props) {
  const navigate = useNavigate();
  let { id } = useParams();
  // const colorPicker = useRef();
  const [module, setModule] = useState(null);
  const [moduleObj, setModuleObj] = useState(null);
  const [showError, setShowError] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [animOpen, setAnimOpen] = useState(false);
  const [dropDown, setDropDown] = useState();
  const [editField, setEditField] = useState(null);
  // const [showAnimDropDown, setShowAnimDropDown] = useState(false);
  const [showEventForm, setShowEventForm] = useState(false);
  const [activeTag, setActiveTag] = useState();
  const [formError, setFormError] = useState();
  const [narrativeHeadings, setNarrativeHeadings] = useState();
  const [flatCatMenuItems, setFlatCatMenuItems] = useState();
  const [unSavedChanges, setUnSavedChanges] = useState({});
  const [tempColor, setTempColor] = useState();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [icons, setIcons] = useState();
  const [events, setEvents] = useState();
  const [multiDay, setMultiDay] = useState();
  const [fieldErrors, setFieldErrors] = useState();
 

  useEffect(() => {
    props.setTools("canvas")
    fetchJSON(null);

    props.setSmLogo(true)
    return () => {
      props.setSmLogo(false);
    }
    
  }, []);

  useEffect(() => {

    if (moduleObj) {
      animModalIn(moduleObj.id)
      if (moduleObj.multi_day) {
        setMultiDay(true)
      } else {
        setMultiDay(false)
      }
     
    } else {
      setUnSavedChanges({})
    }
  }, [moduleObj])

  useEffect(() => {
    if (module) {
      if (activeTag) {
        let eventCp = [...module.events];
        let filtered = eventCp.filter(a => 
          a.tags.findIndex(b => b.id === activeTag) > -1
        );
        // console.log('activeTag', activeTag, filtered, eventCp)
        if (filtered.length > 0) {
          setEvents(filtered);
        } else {
          setEvents([]);
        }
        
      } else {
        setEvents(module.events)
      }
    }
    
  }, [activeTag, module]);

  useEffect(() => {

    if (module) {

      if (module.events) {
        setEvents(module.events)
      }

        let newList = [];

        module.tags.forEach((obj, i) => {
          let exists = newList.findIndex(a => a.id === parseInt(obj.id))

            if (!obj.parent && exists < 0) {
              

                let listObj = {
                    id: parseInt(obj.id),
                    text: "<span>" + obj.text + "</span>",
                    visible: null,
                    locked: null,
                    children: []
                }
                newList.push(listObj);

            } else {
              
              let parentIndex = newList.findIndex(a => a.id === parseInt(obj.parent))
              console.log('parentIndex', parentIndex, obj.parent, newList)

              if (parentIndex > -1) {
                newList[parentIndex] && newList[parentIndex]['children'].push({
                  id: parseInt(obj.id),
                  text: "<span>" + obj.text + "</span>",
                  visible: null,
                  locked: null,
                  children: []
                });
           
              } 
              else {
                let parentObj = module.tags.find(a => a.id === obj.parent);
                if (parentObj){
                  let listObj = {
                    id: parentObj.id,
                    text: "<span>" + parentObj.text + "</span>",
                    visible: null,
                    locked: null,
                    children: [{
                      id: obj.id,
                      text: "<span>" + obj.text + "</span>",
                      visible: null,
                      locked: null,
                      children: []
                    }]
                  }
                  console.log('listObj', listObj)
                  newList.push(listObj);
                }
                  
              }
             
            }

        });
        console.log("newList", newList)
      setFlatCatMenuItems(newList);
    
    }
    

  }, [module])


  useEffect(() => {
    if (dropDown) {
      animDropDown(true)
    } else {
      animDropDown(false)
    }
  }, [dropDown])

  useEffect(() => {
    if (!showEventForm) return;
  
      const handleKeyPress = (event) => {
        if (event.key === "Enter") {
          handleAddEvent(document.getElementById('newEventName').value)
        }
      };
  
      window.addEventListener("keydown", handleKeyPress);
  
      return () => {
        window.removeEventListener("keydown", handleKeyPress);
      };
  }, [showEventForm])


  function handleBackBtn(){
    navigate('/narratives/' + module.narrative)
    setShowError(false);
  }

  function animDropDown(open){
    if (open) {
      // let parent = document.getElementById('settingsRow_' + dropDown).getBoundingClientRect().x;
      let parent = document.getElementById('settingsRow_' + dropDown).offsetLeft;
      let dropDownElem = document.getElementById("inputField_" + dropDown + "_" + moduleObj.id ).offsetLeft;
      let offsetLeft = parent - dropDownElem;
      // console.log('offsetLeft', offsetLeft);
      // gsap.to(dropDownElem, {y: offsetLeft, duration: 0});
      var tl = gsap.timeline();
      tl.to("#inputField_" + dropDown + "_" + moduleObj.id + " .dropDownChoices", {height: "auto", duration: 0});
      tl.to("#inputField_" + dropDown + "_" + moduleObj.id, {zIndex: 3, x: offsetLeft, height: "auto", duration: 0}, "<");
      tl.to("#inputField_" + dropDown + "_" + moduleObj.id, {scale: 1, opacity: 1, duration: 0.1});
    } else {
      gsap.to(".dropDownChoices", {height: 0, duration: 0});
      gsap.to(".dropDownField", {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
    }
  }


  
  // let moduleObjs = [];

  function animColorPicker(open, id){
    if (open !== id) {
      var tl = gsap.timeline();
      tl.to("#" + id, {height: "auto", duration: 0});
      tl.to("#" + id, {zIndex: 3, height: "auto", duration: 0}, "<");
      tl.to("#" + id, {scale: 1, opacity: 1, duration: 0.1});
      setAnimOpen(id);
    } else {
      gsap.to("#" + id, {height: 0, duration: 0});
      gsap.to("#" + id, {opacity: 0, scale: 0, zIndex: -1, duration: 0.1});
      setAnimOpen(null);
    }
  }

  
  // function getModules(paths) {
  //   let moduleObjs = [];
  //   for(var i = 0; i < paths.length; i++) {            
  //     try {
  //       axios({
  //           method: "get",
  //           url: paths[i],
  //           headers: {
  //             'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
  //           },
  //       }).then((response) => {
  //           const objJSON = response.data;
  //           moduleObjs.push(objJSON);

  //           if (paths.length === moduleObjs.length) {
  //             setModules(moduleObjs);
  //             console.log('modules', moduleObjs, paths.length)
  //           }
           
  //       });
  //     } catch (error) {
  //         console.error(error);
  //     }  
  //   }
   
  //   return paths.length === moduleObjs.length;
  // }

  function fetchJSON(objId) {

    console.log('fetchJSON', objId)
 
    try {
        axios({
            method: "get",
            url: Config.baseURL + "/api/cms/timeline/" + id,
            headers: {
              'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
            },
        }).then((response) => {
            const assetJSON = response.data;
            setModule(assetJSON);
            if (objId){
              console.log('fetchJSON', objId, assetJSON)
              let obj = assetJSON['events'].find(a => a.id === objId)
              setModuleObj(obj)
            }

            try {
              axios({
                  method: "get",
                  url: Config.baseURL + "/api/cms/narrative-headings/" + assetJSON.narrative + '/',
                  headers: {
                    'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
                  },
              }).then((response) => {
                  const headings = response.data;
                  console.log('headings', headings.narrativeheadings)
                  setNarrativeHeadings(headings.narrativeheadings);
                  setShowLoader(false);
                  
              });
            } catch (error) {
                console.error(error);
            }
            
           
            console.log('timeline json', assetJSON)
        });
    } catch (error) {
        console.error(error);
    }

    try {
      axios({
          method: "get",
          url: Config.baseURL + "/api/cms/timeline-icon/",
          headers: {
            'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
          },
      }).then((response) => {
          const assetJSON = response.data;
          setIcons(assetJSON);
          
      });
    } catch (error) {
        console.error(error);
    }

    



    
}

    function handleAddEvent(heading) {
      setTempColor(null);
      setShowLoader(true);
      setShowEventForm(false);
      const api_url = Config.baseURL + '/api/cms/timeline/' + id + "/";
      var dataJSON = {};
      dataJSON['status'] = "new"
      dataJSON['heading'] = heading
      axios({
          method: 'POST',
          url: api_url,
          data: dataJSON,
          headers: {
            'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
          },
      })
      .then(response => {
          console.log('add file response', response.data['id'])
          fetchJSON(response.data['id']);
          // if (catId){
          //   console.log('catId', catId)
          //   setAssignCatId(catId);
            
          // }
      })
      .catch(error => {
          console.log('error', error.response);
      });
    }



  function animModalIn(objId){
    let target = "#moduleDetail_" + objId;
    gsap.to(target, {opacity: 1, duration: 0.2})
  }

  function animModalOut(objId, file){
    let hasStartDate = moduleObj.start_date || unSavedChanges['start_date'];
    if (!hasStartDate) {
      setFieldErrors(true)

    } else {
      let target = "#moduleDetail_" + objId;
    if (file) {
      gsap.to(target, {opacity: 0, duration: 0.2, onComplete: setModuleObj(null)});
    } else {
      // handleModuleSave('delete', true)
      setTimeout(() => {

        gsap.to(target, {opacity: 0, duration: 0.2, onComplete: setModuleObj(null)});
      }, 300);
    }
    }
    
   
    


  }


function handleDropDown(e, field) {
  if (field === dropDown) {
    setDropDown(null); 
  } else {
    setDropDown(field)
  }
}

function handleOnKeyUp(e, field) {
    // let changes = [...unSavedChanges];
    let changes = { ...unSavedChanges };
    if (changes[field]) {
      changes[field] = e.target.value;
    } else {
      changes[field] = e.target.value
    
        
    }
    setUnSavedChanges(changes)
    console.log('changes', changes)
}

function handleOnChoice(value, field) {
  let changes = { ...unSavedChanges };
  if (changes[field]) {
    changes[field] = value;
  } else {
    changes[field] = value
  
      
  }
  setDropDown(false)
  setUnSavedChanges(changes)
  console.log('changes', changes, changes.length)
}

function handleActiveTag(objId) {
  console.log('handleActiveTag', objId)
  setActiveTag(parseInt(objId))
  
}

function onLayerClick(id){
  console.log('onLayerClick', id)
  // handleActiveTag(id)
}

function onEventClick(obj) {
  console.log('onEventClick', obj)
  setTempColor(null);
  setModuleObj(obj)
  setFieldErrors(false)
}

function onSave(delEvent){

  console.log('onSave Timeline', unSavedChanges['start_date'])
  let hasStartDate = (moduleObj.start_date || (moduleObj.start_date && (unSavedChanges['start_date'] && unSavedChanges['start_date'] !== null))) || (moduleObj.start_date === null && (unSavedChanges['start_date'] && unSavedChanges['start_date'] !== null));

  if (hasStartDate) {
    console.log('onSave')
    setFieldErrors(false)
    setShowLoader(true);
    const api_url = Config.baseURL + '/api/cms/timeline-event/' + moduleObj.id + "/";
    var dataJSON = { ...unSavedChanges };
    dataJSON['timeline'] = id.replace('timeline-', '')
  
    if (delEvent) {
      dataJSON['delete'] = true
    }
  
    console.log('handleModuleSave', dataJSON, unSavedChanges)
    axios({
        method: 'POST',
        url: api_url,
        data: dataJSON,
        headers: {
          'Authorization': 'Token ' + Cookies.get('_expo_tokenid')
        },
    })
    .then(response => {
        console.log('handleModuleSave', response);
        setDropDown(null);
        fetchJSON(moduleObj.id);
        setUnSavedChanges({})
        setShowLoader(false);
  
    })
    .catch(error => {
        console.log('error', error.response);
    });
  } else {
    setFieldErrors(true)
  }



}


const onDateSelect = (name, date) => {
  // console.log('onDateSelect', name, date)
  let dateFormatted;
  if (date !== null) {
    // const datePattern = 'yyyy-MM-dd';
    dateFormatted = DateToApi(date).split('T')[0];
  } else {
    dateFormatted = null;
  }
  handleOnChoice(dateFormatted, name)
  setShowDatePicker(false);
};

useEffect(() => {
  let l;
  if (showDatePicker !== false) {
    l = document.addEventListener('click', function(event) {  
      if (event.target.closest(".dateFilter")) return 
      setShowDatePicker(false)
    } , true);
    
  } else {
   
    document.removeEventListener("click", l);
  }
  
}, [showDatePicker])



function onTagSort(items){
  console.log('onTagSort received', items);
  const api_url = Config.baseURLcms + 'tags-reorder/';
  let formData = {}
  formData['objs'] = items;
  console.log('sending tags reorder', formData['objs'])

  function responseTask() {
    fetchJSON();

  }
  apiCall("POST", api_url, formData, responseTask, null, setFormError, setShowLoader)
}

function onMultiDay(){
  // handleOnChoice(value, field)
  setMultiDay(!multiDay)
  handleOnChoice('false', 'multi_day')

}

function onClearPage(){
  
  handleOnChoice(null, 'page')
  
}

function onIconClick(file, id) {
  if (moduleObj.icon === file) {
    handleOnChoice(null, 'icon')
  } else {
    handleOnChoice(id, 'icon')
  }
  
}


    return (
        <section className="main" id="timelinePage">
        {(showLoader)?(<div id="loading"><img src={Loader} alt="" /></div>):null}

        {(formError)&&<Modal heading={formError.heading} text={formError.text} onBtn1Click={setFormError} onBtn1={null} btn1Text={"Close"} onBtn2Click={null} onBtn2={null} btn2Text={null} />}

        {(showError)&&(<div id="errorPopup"><div className="modal"><span><h3>Unsaved Changes</h3><p>Are you sure you want to go back?</p></span> <div className="fullRow errorRow"><span onClick={() => handleBackBtn('cancel')}>Cancel</span> <span onClick={() => handleBackBtn('force')}>Continue</span></div></div></div>)}

        {(showEventForm)&&(<div className="modalContainer"><div className="modal"><span><h3>New Event</h3>

        <div className="settingsRow">
          <input type="text" autoComplete="off" id="newEventName" autoFocus placeholder="Add Event Heading" />
        </div>

        </span> <div className="fullRow errorRow"><span onClick={() => {
          setShowEventForm(false)
        }}>Cancel</span> <span onClick={() => handleAddEvent(document.getElementById('newEventName').value)}>Continue</span></div></div></div>)}
        
        
        {module && <div className="col appGrid">

        <div id="narrativeTools">

        <div className="iconField ui" onClick={() =>setShowEventForm(true)}><Icons.Plus className="icon ui" title="Add File" onMouseEnter={(e) =>props.onMouseEnter(e, "Add Event")} onMouseLeave={() => props.onMouseLeave() } /></div>
          
          <h1>{module.title}</h1>

          <a href={ Config.previewURL + "/narrative/" + module.narrative + '?u=' + props.user.link_token + "&module=" + module.id} className="previewBtn previewBtnGallery" target="_blank" rel="noreferrer" title="preview">
          <img src={OpenLink} className="icon" alt="" /></a>

          </div>
            <nav className={classNames('leftNav', style.timelineFilters)}>
            
  
              <div className="leftArrow iconField" onClick={() => handleBackBtn()}>
                <ArrowBack className="icon" /> 
  
                <div className="pages">Spaces Overview</div>
              </div>

              <div className="pages fieldRow modulePages">
                  <div  className="sectionRows">
                  

                    <div className="layerToggle">
                    <span className={`layerToggleBtn on`}>Tags</span>

                   
                  </div>
                  
                  {flatCatMenuItems && 
                    <div 
                    className={"sortableBox"}
                  >
                  <SortableTree  
                    defaultItems={flatCatMenuItems}
                    indicator
                    collapsible
                    category={'parent'}
                    activationConstraint={{
                      delay: 200,
                      tolerance: 15,
                    }} 
                    activePageId={props.activeSettingId}
                    onMenuSort={onTagSort}
                    onItemClick={onLayerClick}
                    isDragActive={true}
                    allowNesting={true}
                  />
                  </div>
                }



                  
                  </div>

              </div>
            </nav>
            <div className="core noPad">

            <div className="splitCol">
              <span className={`flex flexColumn ${style.events}`}>
              
              {events && events.map((obj, i) => (
                  <span key={'event_'+i} className={i === events.length -1 ? style.lastEventBlock : undefined}>
                    {obj.multi_day && <span 
                  className={style.headerColor}
                  style={{backgroundColor: obj.color ? obj.color : '#555555'}}
                  ></span>}
                    <span 
                    
                    onClick={() => onEventClick(obj)}
                    style={{backgroundColor: obj.color && !obj.multi_day ? obj.color : '#555555'}}
                    className={
                      classNames(
                        obj.multi_day && style.multiDay,
                        style.eventBlock,
                        "ui"
                      )}
                    >
                     
                      <span className={style.eventBlockBox}>
                        <span className={`flex alignCenter`}>

                        <span className="icon">
                          {obj.icon && <img src={Config.mediaURL + obj.icon} alt="" />}
                        </span>


                         <span className={style.heading}>{obj.heading}</span>
                          
                          <span className="flex tags gap10">
                       
                            {obj.tags.map((tag, j) => (
                              <span className={style.tag} key={'eventTag_' + j}>{tag.text}</span>
                            ))}

                          </span>
                        </span>

                        <span className={"flex gap5"}>
                       {obj.start_date_predicted && !obj.end_date_predicted && <span className={`flex ${style.dateLine} gap10 alignCenter`}>
                         <Calendar /> <span>Predicted</span>
                          <strong>{format(new Date(zonedTimeToUtc(obj.start_date_predicted, Intl.DateTimeFormat().resolvedOptions().timeZone)), "MMM d, Y")}</strong>
                 
                        </span>}
                        {obj.start_date && !obj.end_date && <span className={`flex ${style.dateLine} gap10 alignCenter`}>
                         <Calendar /> <span>Actual</span>
                         <strong>{format(new Date(zonedTimeToUtc(obj.start_date, Intl.DateTimeFormat().resolvedOptions().timeZone)), "MMM d, Y")}</strong>
                        </span>}
                        </span>
                        <span className={"flex gap5"}>
                        {obj.start_date_predicted && obj.end_date_predicted && <span className={`flex ${style.dateLine} gap10 alignCenter`}>
                         <Calendar /> <span>Predicted</span>
                          <strong>
                          {getDateDifference(obj.start_date_predicted, obj.end_date_predicted).weeks > 0 ?
                         `${getDateDifference(obj.start_date_predicted, obj.end_date_predicted).weeks} weeks (${getDateDifference(obj.start_date_predicted, obj.end_date_predicted).days} days)`: `${getDateDifference(obj.start_date_predicted, obj.end_date_predicted).days} days`}
                         </strong>
                 
                        </span>}

                        {obj.start_date && obj.end_date && <span className={`flex ${style.dateLine} gap10 alignCenter`}>
                        <Calendar /> <span>Actual</span>
                        <strong>
                          {getDateDifference(obj.start_date, obj.end_date).weeks > 0 ?
                         `${getDateDifference(obj.start_date, obj.end_date).weeks} weeks (${getDateDifference(obj.start_date, obj.end_date).days} days)`: `${getDateDifference(obj.start_date, obj.end_date).days} days`}
                         </strong>
                
                       </span>}
                       </span>

                      </span>
                         
                    </span>  
                    </span> 
                    ))}

              </span>

              <span className={classNames(
                "settingsPanel",
                "empty"
              )}>
              {moduleObj ?
                <span key={'moduleObj' + moduleObj.id} className={style.eventDetail} id={"moduleDetail_" + moduleObj.id}>
                
                <div className="settingsContainer">
                    <div className="closeModal ui" onClick={() => {animModalOut(moduleObj.id, moduleObj.file) }}><Close className="icon" /></div>
                    
            
                    <div className="moduleSettings">

                    <div>
                      <div className="groupLabel"><p>Event Settings</p></div>
              


                      <div className="settingsRow">
                          <div className="moduleHeading" id={"inputField_title" + moduleObj.id}>
                          <div className="fieldRow">
                              <div className="errors"></div>
                      
                              <div className="canvasLabel">Title</div>
                              <input type="text" autoComplete="off" id="title" defaultValue={moduleObj.heading} onKeyUp={(e) => handleOnKeyUp(e, 'heading')} />
                          
                          </div>
                          
                          </div>
                      </div>

                      <div className={`settingsRow flex alignTop`}>

                      <span className={`flex flexColumn gap5`}>
                        <div className="canvasLabel">Multi Days</div>
                        <span 
                        onClick={() => onMultiDay()}
                        className={classNames(
                          multiDay && style.on,
                          style.checkBox,
                          "ui"
                        )}>
                        {multiDay && <Icons.Close />}
                        </span>
                      </span>
                      
                        <span className={`flex flexColumn gap5`}>
                          <div className="canvasLabel ui" onClick={() => animColorPicker(animOpen, 'colorPicker0')}>Color</div>
                          <div className={`ui colorChip ${style.tlColorChip}`} 
                          style={{
                            background: tempColor?tempColor:moduleObj.color?moduleObj.color:"none"
                          }}
                          onClick={() => animColorPicker(animOpen, 'colorPicker0')}></div>
                      
                          <span 
                          id="colorPicker0"
                          className="colorPicker"
                          >
                          <SketchPicker
                              color={tempColor?tempColor:moduleObj.color?moduleObj.color:""}
                              disableAlpha={true}
                              presetColors={["#A94B4B", "#A97E4B", "#A3A94B","#4BA950","#4BA98B","#4B97A9","#4B56A9","#804BA9","#A94BA3","#A94B74","#A6A6A6","#595959"]}
                              onChange={(color) => {
                                setTempColor(color.hex)
                              }}
                              onChangeComplete={(color, event) => {
                                // console.log('color, event', color, event)
                                
                                if (tempColor && !color.hex) {
                                  console.log('tempColor', tempColor)
                                  handleOnChoice(tempColor, 'color')
                                } else if (!tempColor && color.hex) {
                                  console.log('color.hex', color.hex)
                                  handleOnChoice(color.hex, 'color')
                                } else if (tempColor && color.hex) {
                                  handleOnChoice(color.hex, 'color')
                                } else {
                                  console.log('onChangeComplete', color.hex)
                                }
                              }}
                            />
                            
                            </span>
                        </span>

                        {!multiDay && <span className="flex flexColumn gap5">
                          <div className="canvasLabel">Symbol</div>
                          <span className="flex gap5 wrap">
                          {icons && icons.map((obj, i) => (
                            <span 
                              key={'icon_' + i}
                              onClick={() => onIconClick(obj.file, obj.id)}
                              className={classNames(
                                style.icon,
                                "ui",
                                ((moduleObj.icon && moduleObj.icon === obj.file && !unSavedChanges['icon'])||(unSavedChanges['icon'] && unSavedChanges['icon'] === obj.id))  && style.iconOn
                              )}  
                            >
                              <img src={Config.mediaURL + obj.file} alt="symbol" />
                            </span>
                          ))}
                          </span>
                           
                        </span>}
                      
                      </div>

                      <div className={classNames(
                        "settingsRow",
                        "flex",
                        "flexColumn",
                        "gap5"
                      )}>
                      <div className="canvasLabel flex alignCenter gap10"><Calendar /> Predicted</div>    
                      <div className="grid grid2">
                        <DateField
                          heading={null}
                          name="Start Date"
                          date_key="start_date_predicted"
                          value={moduleObj.start_date_predicted}
                          onDateSelect={onDateSelect}
                          yearPicker={true}
                        />
                        {multiDay &&<DateField
                        heading={null}
                        name="End Date"
                        date_key="end_date_predicted"
                        value={moduleObj.end_date_predicted}
                        onDateSelect={onDateSelect}
                        yearPicker={true}
                      /> }
                      </div>
                      </div>

                      <div className={classNames(
                        "settingsRow",
                        "flex",
                        "flexColumn",
                        "gap5",
                        fieldErrors && style.required
                      )}>
                      <div className="canvasLabel flex alignCenter gap10"><Calendar />Actual</div>    
                      <div className="grid grid2">
                        <DateField
                          heading={null}
                          name="Start Date"
                          date_key="start_date"
                          value={moduleObj.start_date}
                          onDateSelect={onDateSelect}
                          yearPicker={true}
                        />
                        {multiDay && <DateField
                        heading={null}
                        name="End Date"
                        date_key="end_date"
                        value={moduleObj.end_date}
                        onDateSelect={onDateSelect}
                        yearPicker={true}
                      /> }
                      </div>
                      </div>
                      


                      <div className="row settingsGridFull" id="settingsRow_page">
                        <div className="canvasLabel">Target Page</div>
                          
                        <div className="dropDownRow">
                            <div className="ui fontBtn" onClick={(e) => handleDropDown(e, 'page')}> 
                           
                                <span className="canvasLabel"> {
                                  ( 
                                    (moduleObj.page_name) || 
                                    unSavedChanges['page'] 
                                  ) 
                                  ? (
                                    moduleObj.page_name && unSavedChanges['page'] === undefined ? 
                                    moduleObj.page_name : 
                                    narrativeHeadings.find(a => a.page === unSavedChanges['page']) && narrativeHeadings.find(a => a.page === unSavedChanges['page']).heading)
                                    : 
                                    !showLoader ? "Select Page" : <span>&nbsp;</span>
                                  }</span>
                                  {console.log('moduleObj.page_name', moduleObj.page_name, unSavedChanges['page'])}
                
                                <Icons.ChevronDown className="icon" /></div>
                            <span className="inputField dropDownField" id={"inputField_page_" + moduleObj.id}>
                            <span className="dropDown">
                                <span className="dropDownChoices">


                                  {narrativeHeadings && narrativeHeadings.sort((a,b) => a.ordering - b.ordering).map((obj, i) => <Fragment key={'dropDown' + i}>
                                  <div className="dropDownChoice ui" onClick={() => handleOnChoice(obj.page, 'page')}>{obj.heading}</div>

                                  {obj.subs && obj.subs.length > 0 && obj.subs.sort((a,b) => a.ordering - b.ordering).map((obj1, i) => <span key={'dropDown' + i} className={"dropDownChoice ui subChoice"} onClick={() => handleOnChoice(obj1.page, 'page')}>
                                  <div className="ui">{obj1.heading}</div>
                                  </span>)}

                                  </Fragment>)}

                                </span>
                            </span>
                            </span> 
                        </div>  

                        <span className={`ui ${style.clear}`} onClick={() => onClearPage()}>Clear</span>

                      </div> 
                      
                      <div className="row">
                        <div className="canvasLabel">Tags</div>
                        <span className="settingsRow">
                            <TagField 
                              eventTags={moduleObj.tags} 
                              handleOnChoice={handleOnChoice}
                              org={module.org}
                              unSavedChanges={unSavedChanges}
                              tags={module.tags.filter(a => !a.has_subs)}
                              tree={flatCatMenuItems}
                              />
                        </span>
                      </div>



                    </div>

                    
                    <div className="settingsRow" id="saveRow">
                    
                        <div className={"closeFormBtn btn" + ((Object.keys(unSavedChanges).length > 0) ? (" unsaved") : (" saved"))} onClick={() => onSave(false)}>Save</div>

                        <div className="iconField ui" onMouseEnter={(e) =>props.onMouseEnter(e, "Double click to delete")} onMouseLeave={() => props.onMouseLeave() } onDoubleClick={() => onSave(true)}>
                          <Delete className="icon"/> <div className="canvasLabel">Delete</div>
                        </div>
                     
            
                    </div>
                    
            
            
                    </div>
            
                    
                </div>
                </span> :

                <span>
                <Timeline />
                Select an event<br/>to adjust settings
                </span>
                
              } 
              </span>
          
              
              </div>
            </div>     
           
          

         </div>}
        




      </section>
    );
}

export default Module;


